import React, { FunctionComponent } from 'react';
import { PostShow } from '../../../types/posts';
import classnames from 'classnames';
import { LuminousGalleryWrapper } from '../../../utils/luminousGallery';

type Props = {
  post: PostShow;
  companyId: number;
};

export const Presentation: FunctionComponent<Props> = ({
  post,
  companyId,
}) => {
  return (
    <div className="l-articles js-background-fixed">
      <div className="l-articles-inner l-articles-inner--flex u-clear">
        <main className="l-articles-main l-articles-main--story">
          <div className="articles-list">
            <ul className="articles-list-inner">
              <li className="articles-list-story">
                <div className="articles-list-story-show">
                  {post.title ? (
                    <h1 className="articles-list-story-show-title">{post.title}</h1>
                  ) : (
                    <div
                      className="articles-list-story-body-without-title"
                      dangerouslySetInnerHTML={{ __html: post.body }}
                    />
                  )}
                </div>

                {post.title && (
                  <div
                    className="articles-list-story-body"
                    dangerouslySetInnerHTML={{ __html: post.body }}
                  />
                )}

                {post.images?.length > 0 && (
                  <LuminousGalleryWrapper>
                    <div className="articles-list-story-images">
                      {post.images.map((img, index) =>
                        <a
                          href={img.url}
                          className={classnames(
                            "luminous",
                            img.isWide
                              ? "articles-list-story-images-wide"
                              : "articles-list-story-images-narrow"
                          )}
                          key={index}
                        >
                          <img src={img.url} alt={img.alt} />
                        </a>
                      )}
                    </div>
                  </LuminousGalleryWrapper>
                )}

                {post.hashtags?.length > 0 && (
                  <p className="articles-list-story-hashtag">
                    {post.hashtags.map((tag, index) => (
                      <span key={index}>{tag} </span>
                    ))}
                  </p>
                )}

                <time dateTime={post.updatedAt} className="articles-list-story-time">
                  更新 {post.formattedUpdatedAt}
                </time>

                <a href={`/companies/${companyId}/stories`} className="articles-title-link">
                  ストーリー一覧へ
                </a>
              </li>
            </ul>
          </div>
        </main>

      </div>
    </div>
  );
};
